module.exports = __webpack_public_path__ + "img/图片10.74f6aa66.png";